/**
 * Updates multiple value(s) for incident(s) without refetching from API.
 * This can be used if you need to update multiple incidents
 * and/or multiple values.
 *
 * @param {Array<Object>} stateValue state value from the store
 * @param {Object} payload action.payload
 * @param {(string|Array)} fieldNames name the field, or field(s) to update
 * @returns {Array<Object>} incidents with updated values
 */
export const updateMultipleIncidentValues = (
  stateValue,
  payload,
  fieldNames
) => {
  const {incidents} = payload;
  const hasMultipleFieldNames = Array.isArray(fieldNames);

  if (stateValue && incidents && incidents.length > 0) {
    return stateValue.map((storedIncident) => {
      const matchingIncident = incidents.find(
        (newIncident) => newIncident.id === storedIncident.id
      );

      if (matchingIncident) {
        if (hasMultipleFieldNames) {
          fieldNames.map(
            (field) => (storedIncident[field] = matchingIncident[field])
          );
        } else {
          storedIncident[fieldNames] = matchingIncident[fieldNames];
        }
      }
      return storedIncident;
    });
  } else {
    return stateValue;
  }
};
